<template>
  <div class="bg-white border border-black/6 rounded-[20px] p-6 shadow-[0_2px_12px_rgba(0,0,0,0.04)]">
    <div class="flex items-center justify-between mb-4">
      <span class="text-[11px] font-bold uppercase tracking-[0.06em] text-muted">Communication</span>
      <a href="#" @click.prevent="startAdding" class="text-[13px] font-medium text-primary no-underline transition-colors duration-150 hover:opacity-80 hover:no-underline">+ Add item</a>
    </div>

    <div v-if="items.length === 0 && !isAdding" class="flex flex-col items-center py-5 pb-2 text-muted">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
      <p class="text-[13px] text-placeholder mt-2 mb-0">No checklist items</p>
    </div>

    <div v-else class="flex flex-col gap-0.5">
      <div
        v-for="(item, idx) in items"
        :key="idx"
        class="group flex items-center gap-2.5 py-1.5 rounded-lg transition-colors duration-150 hover:bg-canvas -mx-1.5 px-1.5">
        <button
          class="shrink-0 w-[20px] h-[20px] rounded border-2 cursor-pointer flex items-center justify-center transition-all duration-150 p-0"
          :style="item.checked ? 'background:#2d7a0e;border-color:#2d7a0e;color:#fff' : ''"
          :class="item.checked ? '' : 'bg-white border-black/15 hover:border-primary'"
          @click="$emit('toggleItem', idx)">
          <svg v-if="item.checked" xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </button>

        <span class="text-[13px] leading-tight flex-1 min-w-0" :class="item.checked ? 'line-through text-muted' : 'text-ink'">
          {{ item.label }}
        </span>

        <a
          v-if="!item.predefined"
          href="#"
          @click.prevent="$emit('deleteItem', idx)"
          class="shrink-0 flex items-center justify-center w-6 h-6 rounded-md text-placeholder no-underline opacity-0 group-hover:opacity-100 transition-all duration-150 hover:bg-[#fff5f5] hover:text-[#e53935] hover:no-underline"
          title="Remove">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </a>
      </div>
    </div>

    <!-- Inline add input -->
    <div v-if="isAdding" class="mt-2">
      <input
        ref="addInput"
        v-model="newLabel"
        type="text"
        placeholder="e.g. Follow-up call scheduled"
        class="w-full border border-black/12 rounded-lg py-2 px-3 text-[13px] font-[inherit] text-ink bg-canvas outline-none transition-[border-color,box-shadow] duration-150 placeholder:text-placeholder focus:border-primary focus:shadow-[0_0_0_3px_rgba(124,91,234,0.1)]"
        @keydown.enter="submitItem"
        @keydown.escape="cancelAdding">
      <div class="flex gap-2 mt-2">
        <button
          class="px-3 py-1 text-[12px] font-medium text-white bg-primary border-none rounded-md cursor-pointer transition-opacity duration-150 hover:opacity-85"
          @click="submitItem">Add</button>
        <button
          class="px-3 py-1 text-[12px] font-medium text-muted bg-transparent border border-black/10 rounded-md cursor-pointer transition-colors duration-150 hover:bg-canvas"
          @click="cancelAdding">Cancel</button>
      </div>
    </div>

    <!-- Summary -->
    <div v-if="items.length > 0" class="mt-4 pt-3 border-t border-[#f5f3f7]">
      <span class="text-[11px] font-semibold py-0.5 px-2.5 rounded-full" :class="checkedCount === items.length ? 'bg-[#e8f5e9] text-[#2d7a0e]' : 'bg-border text-primary'">
        {{ checkedCount }} of {{ items.length }} done
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact-checklist',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isAdding: false,
      newLabel: ''
    }
  },
  computed: {
    checkedCount () {
      return this.items.filter(item => item.checked).length
    }
  },
  methods: {
    startAdding () {
      this.isAdding = true
      this.newLabel = ''
      this.$nextTick(() => {
        if (this.$refs.addInput) {
          this.$refs.addInput.focus()
        }
      })
    },
    submitItem () {
      const label = this.newLabel.trim()
      if (!label) return
      this.$emit('addItem', label)
      this.newLabel = ''
      this.isAdding = false
    },
    cancelAdding () {
      this.isAdding = false
      this.newLabel = ''
    }
  }
}
</script>
